







































































import { CampaignReportData } from "@/models/CampaignReport";
import AdUnit from "@/models/adUnit";
import { DefinitionList } from "@/models/definition";
import Site from "@/models/site";
import { LayoutModule } from "@/store/layout";
import moment from "moment";
import { Component, Vue, Prop } from "vue-property-decorator";
import CampaignReportInfo from "./CampaignReportInfo.vue";
import ClientCampaignReportDetail from "./ClientCampaignReportDetail.vue";
import ClientCampaignReportSummary from "./ClientCampaignReportSummary.vue";
import Campaign from "../../../models/campaign";
@Component({
  components: {
    CampaignReportInfo,
    ClientCampaignReportDetail,
    ClientCampaignReportSummary,
  },
})
export default class ClientCampaignReport extends Vue {
  @Prop() inputData!: CampaignReportData;
  appLogo = require("@/assets/app-logo.png");
  data: CampaignReportData | null = null;
  adUnits: AdUnit[] = [];
  definitions: DefinitionList[] = [];
  sites: Site[] = [];
  dateRange: string[] = [];
  loading = false;
  defaultLang = "es";
  tabs = null;

  async created(): Promise<void> {
    this.defaultLang = this.$route.query.lang
      ? (this.$route.query.lang as string)
      : "es";

    moment.locale(this.defaultLang);

    this.loading = true;
    LayoutModule.showLoader();

    this.sites = this.inputData.sites
      ? this.validSites(this.inputData.sites)
      : [];
    this.adUnits = this.inputData.adUnits ? this.inputData.adUnits : [];
    this.definitions = this.inputData.definitions
      ? this.inputData.definitions
      : [];
    this.data = { ...this.inputData };

    this.dateRange = [
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().endOf("month").format("YYYY-MM-DD"),
    ];

    if (this.$route.query.lang) {
      this.defaultLang = this.$route.query.lang as string;
    }

    this.$i18n.locale = this.defaultLang;

    this.loading = false;
    LayoutModule.hideLoader();
  }

  validSites(sites: Site[]): Site[] {
    return sites.filter((s) => {
      return [
        "PortalFruticola.com",
        "FreshFruitPortal.com",
        "ChinaFruitPortal.com",
      ].includes(s.name);
    });
  }

  getSite(name: string): Site {
    const site = this.sites.find((s) => s.name === name);
    return site ? site : new Site();
  }

  siteHasData(site: Site): boolean {
    if (this.data) {
      const lineItemsIds = (this.data.campaign as Campaign).lineItems
        .filter((l) => l.siteId === site.id)
        .map((l) => l.id);
      return lineItemsIds.length > 0 ? true : false;
    }
    return false;
  }

  get startMonth(): string {
    return this.data
      ? moment(this.inputData.meta.report.start).format("MMMM YYYY")
      : "";
  }

  get endMonth(): string {
    return this.data
      ? moment(this.inputData.meta.report.end).format("MMMM YYYY")
      : "";
  }

  get startDate(): string {
    return this.data
      ? moment(this.data.meta.report.start).format("DD MMM YYYY")
      : "";
  }

  get endDate(): string {
    return this.data
      ? moment(this.data.meta.report.end).format("DD MMM YYYY")
      : "";
  }

  get getDateTitle(): string {
    return "";
  }
}
